var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-card',{staticClass:"shadow",attrs:{"closed":!_vm.isOpen,"headerText":_vm.headerText}},[_c('div',[_vm._t("default",function(){return [_c('p',[_vm._v("Default accordion content")])]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }